module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/logo-the-ready-state-6af5654a24218f2a34d49a7b9fab23f5.svg";